export const MACHINERY_TAGS = {
    MACHINERY_LIST: "Machineries",
    MACHINERY_UPDATE_REQUESTS: "MachineryUpdateRequests",
} as const;